// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_markdownPreview_qQsDHulU82tFfeKaBF9A ul, .style-module_markdownPreview_qQsDHulU82tFfeKaBF9A ol {
  list-style: revert;
}`, "",{"version":3,"sources":["webpack://./src/components/MarkdownPreview/style.module.scss"],"names":[],"mappings":"AACC;EACG,kBAAA;AAAJ","sourcesContent":[".markdownPreview {\n ul, ol {\n    list-style: revert;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markdownPreview": `style-module_markdownPreview_qQsDHulU82tFfeKaBF9A`
};
export default ___CSS_LOADER_EXPORT___;
